import { VERSION } from './version';

export const environment = {
  legacyApiURL: 'https://apis.lativ.com.tw',
  ssrEndPointUrl: 'http://gateway:8080',
  endPointUrl: 'https://www.lativ.com.tw',
  legacyEndPointUrl: 'https://legacy.lativ.com.tw',
  shortUrl: 'https://lativ.tw',
  fileScheme: 'https://cdx.lativ.com.tw/upload-v1',
  fbOauthPath: 'https://www.facebook.com/v17.0/dialog/oauth',
  appleAuthPath: 'https://appleid.apple.com/auth/authorize',
  fbAppId: '107063260011289',
  bugsnagApiKey: 'b3f187b6cc362e2ad7c69ba7471a0110',
  appleClientID: 'com.lativ.iShopping.TW.client',
  production: true,
  releaseStage: 'production',
  appVersion: VERSION.hash,
  firestore: {
    users: 'users',
    sessions: 'sessions',
    messages: 'messages',
  },
  firebase: {
    apiKey: 'AIzaSyCh4aJZE7Zbnv_y9Nk7K9HROc7YrTQw6Kw',
    authDomain: 'lativ-next.firebaseapp.com',
    projectId: 'lativ-next',
    storageBucket: 'share-store-prod-626',
    messagingSenderId: '760274956123',
    appId: '1:760274956123:web:2b69271143ebd74189b47e',
    measurementId: 'G-507WQ4GMXH',
  },
};
